import { Record } from 'immutable';

export default class OrderRecord extends Record({
    id: null,
    createdAt: null,
    account_id: null,
    sale_id: null,
    remote_transaction_id: null,
    payment_method: 'CREDIT_CARD',
    processing_fee: 0,
    status: 'unpaid'
  }) {
    constructor(data) {
      if (data.payment_method === 'CREDIT_CARD') data.payment_method = 'card';
      if (data.payment_method === 'CASH') data.payment_method = 'cash';

      super(data)
    }
  }
